const waitForDom = (id, maxWait = 10000, delay = 100) => {
  const promise = new Promise((resolve, reject) => {
    const startTime = new Date().getTime();
    const el = document.getElementById(id);
    if (el == null) {
      const t = setInterval(() => {
        const el = document.getElementById(id);
        if (el) {
          clearInterval(t);
          resolve(el);
        }
        const now = new Date().getTime();
        if (now - startTime > maxWait) {
          clearInterval(t);
          reject("Timed out waiting for DOM element to appear...");
        }
      }, delay);
    } else {
      resolve(el);
    }
  });
  return promise;
};

export default waitForDom;



// WEBPACK FOOTER //
// ./src/modules/wait-for-dom/index.js